import { api } from '@zentrains/api';
import { Identifikation } from '@/model/identifikation.ts';
import { mapToExternalIdentifikation } from '@/mapper/to-api/identifikation.ts';

export function mapToRequestItem(identifkation: Identifikation): api.v3.RefreshReiseRequestItem {
  return {
    id: identifkation.toString(),
    reiseId: mapToExternalIdentifikation(identifkation),
  };
}
